import BaseService from './../base'

export default class AuthorityLevelsService extends BaseService {
  static resource() {
    return 'api/v1/external/authorityLevels'
  }
}
